import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ArrowLeftIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         {...props}
         viewBox="0 0 24 24"
         fill="none"
      >
         <path
            d="M5.07018 10.796L16.2982 0.521739C17 -0.173913 18.2281 -0.173913 18.9298 0.521739C19.6901 1.16388 19.6901 2.28763 18.9298 2.92977L9.04678 11.9732L18.9298 21.0702C19.6901 21.7124 19.6901 22.8361 18.9298 23.4783C18.2281 24.1739 17 24.1739 16.2982 23.4783L5.07018 13.204C4.30994 12.5619 4.30994 11.4381 5.07018 10.796Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ArrowLeftIcon
